export const AkunCategoryFormData = () => {
    return [
        {
            id      : "kategori_akun",
            label   : "Akun Kategori",
            fields  : [{
                type    : "input",
                placeholder: "Masukan Nama Akun Kategori"
            }]
        }
    ];
}